import { Button, ButtonVariant, Collapse, Divider } from "@blueprintjs/core"
import { useState } from "react"
import { ID } from "src/libs/interfaces/layouts"
import FieldInput from "src/libs/scalars"
import { __ } from "src/libs/utilities"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import FieldChanger from "../../views/landing/landing-edit/FieldChanger"

/* Protopia Ecosystem component */
export interface ISingleItemProps {
   schema: any
   value: any 
   i: number
   onChange: ( id: ID, value: any ) => void
}
const SingleItem = (props: ISingleItemProps): JSX.Element => {
    const [isOpen, setIsOpen]   = useState<boolean>(false) 
    const value = useSyncState<any>( props.value || {} )
    const onOpen = () => {
        setIsOpen( !isOpen )
    }
    
    return <div className='pe-single-item'>
        <div className="container">
            <div className='pe-comp-widget row m-1'>            
                <div className="border1 border-contrast-secondary-opacity rounded-1 col-12 p-0">
                    <Button 
                        fill 
                        variant={ ButtonVariant.MINIMAL } 
                        className="btn-stretch m-0" 
                        onClick={ onOpen } 
                        alignText="left" 
                        endIcon={isOpen ? "chevron-down" : "chevron-right"}
                    >
                        <div className="w-100 d-flex align-items-center">                    
                            <div className="lead px-3 py-2">
                                {  value.get()[ props.schema.visible_value ] ||  __( props.schema.name || "Item" ) + " " + props.i }
                            </div>
                            <div className="ml-auto pe-surface">
                                <Button variant={ButtonVariant.MINIMAL} icon="eye-open" title={__("Do hide")} />
                                <Button variant={ButtonVariant.MINIMAL} icon="duplicate" title={__("Double")} />
                                <Button variant={ButtonVariant.MINIMAL} icon="trash" title={__("Delete")} />
                            </div>
                        </div>
                    </Button> 
                    <Collapse isOpen={isOpen} className="overflow-hidden">
                        <div className="w-100 py-3 pl-4 ml-2">
                        {
                            Object.keys( props.schema.apollo_fields )
                            .filter( field => props.schema.apollo_fields[ field ].tab === "main" && !props.schema.apollo_fields[ field ].isHidden )
                            .map( field => {
                                return <FieldInput
                                    key={ field }
                                    editable
                                    value={ value.get()[ field ] }
                                    { ...props.schema.apollo_fields[ field ] }
                                    onChange={props.onChange}
                                />
                            } )
                        }
                        {
                        props.schema.tabs.filter((tab: any) => tab.id !== "main")
                            .map((tab: any) => {
                                return <SingleTab
                                    key={tab.id}
                                    tab={tab}
                                    schema={ props.schema }
                                    value={ value.get() }
                                    onChange={props.onChange}
                                />
                            })
                        }
                        </div>
                        <Divider />
                    </Collapse>
                    
                </div>
            </div>
        </div>
    </div>
}
export default SingleItem


export interface ISingleTabProps { 
    tab: any
    schema: any
    value: any
    className? : string
    contClassName?: string
    btnClassName?: string
    onChange: ( id: ID, value: any ) => void
}

export const  SingleTab = ( props: ISingleTabProps ) : JSX.Element => {
    const [isOpen, setIsOpen]   = useState<boolean>(false) 
    const value = useSyncState<any>( props.value || {} )
    const onOpen = () => {
        setIsOpen( !isOpen )
    } 
    return <div className="w-100 ">
            <div className=" small">
                <div  className={ props.btnClassName || "btn btn-sm btn-link" } onClick={ onOpen }>
                    <small>{ __(props.tab.title) }</small>   
                </div> 
            </div> 
             <Collapse isOpen={isOpen} className="overflow-hidden">
                <div className={ props.contClassName || "w-100 py-3 pl-4 ml-2" }>
                {
                    Object.keys( props.schema.apollo_fields )
                    .filter( field => props.schema.apollo_fields[ field ].tab === props.tab._id && !props.schema.apollo_fields[ field ].isHidden )
                    .map( field => {
                        return <div key={ field } className={ !!props.className ? props.className : "" }>
                            <FieldChanger
                                editable
                                field={field}
                                value={ value.get()[ field ] }
                                { ...props.schema.apollo_fields[ field ] }
                                onChange={props.onChange}
                            />
                        </div>
                    } )
                }
                </div> 
            </Collapse>
   </div>
}